// extracted by mini-css-extract-plugin
module.exports = {"StockCorporateActions":"StockCorporateActions_StockCorporateActions__A7YfL","chips":"StockCorporateActions_chips__CupkA","content":"StockCorporateActions_content__Rvyhj"};